// extracted by mini-css-extract-plugin
export default {"holder":"intro_holder__DFc7T","mainObject":"intro_mainObject__xkxHY"};